import { computed, ref } from "vue";
import { InviteControlApiModel } from "../../api-models";
import { Analytics } from "../../services/analytics/analytics";

export const EmailRegEx =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useInviteControlBase(model: InviteControlApiModel | null) {
  const copied = ref(false);
  const executingCopyViaButton = ref(false);
  const serverSendTab = ref(true);

  function onCopyLink(cb: () => void, inviteModel?: InviteControlApiModel): void {
    Analytics.action("Copied Viewpoints Invite Link", "InviteControlActions", {
      viewpointsInviteUrl: inviteModel?.inviteUrl,
      usedCopyLinkButton: executingCopyViaButton,
    });
    cb();
  }

  function onSendEvent(cb: () => void): void {
    cb();
  }

  const hasAddressBook = computed(() => {
    return !!model?.userTags.some((t) => !!t.id);
  });

  function selectCodeUrl(): void {
    const codeUrlInput = document.getElementById("inviteLink") as HTMLInputElement;
    codeUrlInput.focus();
    codeUrlInput.select();
  }

  function copyToClipboard(cb: () => void): void {
    selectCodeUrl();
    executingCopyViaButton.value = true;
    document.execCommand("copy");
    executingCopyViaButton.value = false;
    copied.value = true;
    cb();
  }

  return {
    copied,
    serverSendTab,
    copyToClipboard,
    onCopyLink,
    onSendEvent,
    hasAddressBook,
    selectCodeUrl,
  };
}
